import router from '../router'
import indexedDB from '@/mixins/indexedDB'

export default async () => {
  const routerName = [
    'statement-info-inspection'
  ]
  router.afterEach((to, from) => {
    if (!routerName.includes(to.name) && routerName.includes(from.name)) {
      indexedDB.methods.deleteDatabase()
    }
  })
}